import React from "react";
import { connect } from "react-redux";

import { getData } from "Source/globalFunction";

import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        files: store.files
    };
})

class UploadedBy extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchIsLoading: false,
            searched: []
        }
    }

    render() {
        const { dispatch, projectId, files } = this.props;

        const searchUser = value => {
            const url = `/api/projects/${projectId}/members`;

            this.setState({ ...this.state, searchIsLoading: true });

            getData(url, {}, response => {
                if (response) {
                    this.setState({
                        ...this.state,
                        searchIsLoading: false,
                        searched: response.data
                            .filter(m => {
                                if (!value) return true;
                                const name = `${m.user['first-name']} ${m.user['last-name']}`.toLowerCase();
                                return name.includes(value.toLowerCase());
                            })
                            .map(m => ({
                                value: m.user.id,
                                label: `${m.user['first-name']} ${m.user['last-name']}`,
                                others: {
                                    id: m.user.id,
                                    firstname: m.user['first-name'],
                                    lastName: m.user['last-name'],
                                    role: m.user.role,
                                    avatar: m.user.avatar
                                }
                            }))
                    });
                }
            });
        }

        const handleOpenSelect = () => {
            searchUser();
        }

        const handleSearch = (value) => {
            searchUser(value);
        }

        const handleSelect = (value) => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {uploadedBy: value} });
        }

        const handleClear = () => {
            dispatch({ type: "UPDATE_FILES_FILTERS", filters: {uploadedBy: {}} });
        }
        
        return (
            <div class="optionRow">
                <span>Uploaded by</span>
                <div class="optionChoices searchIcon">
                    <Select 
                        showSelectedInOptions={false}
                        isSearchable={true}
                        isLoading={this.state.searchIsLoading}
                        classes={{options: "filesFilterOptions"}}
                        placeholder="Search"
                        options={this.state.searched}
                        selected={files.filters.options.uploadedBy}
                        renderOption={option => (
                            <div class="memberOption">
                                <div class="memberMainDetails">
                                    <Avatar name={option.label} disableTooltip={true} image={option.others.avatar !== "default.png" ? `${this.props.avatarBaseUrl}${option.others.avatar}` : null} />
                                    <span>{option.label}</span>
                                </div>
                            </div>
                        )} 
                        onOpen={handleOpenSelect}
                        onSearch={handleSearch}
                        onChange={handleSelect}
                        onClearSelected={handleClear}
                        isClose={files.filters.isCleared}
                    />
                </div>
            </div>
        );
    }
}

export default UploadedBy;